import { List } from '@/icons/index';

import styles from './ChooseTopic.module.scss';

const EmptyBlock = () => (
  <div
    className={styles.emptyBlock}
    itemScope
    itemType='https://schema.org/ItemList'
  >
    <div className={styles.icon}>
      <List />
    </div>
    <div>{'Choose the topic'}</div>
  </div>
);

export default EmptyBlock;
